export default __webpack_public_path__ + "static/bg-powered-565b17b05949cc1c665b62b8cfbfbea0.png";